module.exports = __webpack_public_path__ + "img/文字.38f4a8c9.png";